import skMessages from './messages-sk';

angular
  .module('blocks.i18n')
  .service('messagesSkService', messagesSkService);

function messagesSkService() {
  this.messages = skMessages;
}
